import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ChemicalListItemDto } from '@models/chemical-list-item-dto.interface';
import { EditChemicalDto } from '@models/edit-chemical-dto.interface';
import { SaveChemicalDto } from '@models/save-chemical-dto.interface';

@Injectable({
    providedIn: 'root'
})
export class ChemicalsService {
    private readonly apiService = inject(ApiService);

    getAll(): Observable<ChemicalListItemDto[]> {
        return this.apiService.get('chemicals');
    }

    getForCreate(): Observable<EditChemicalDto> {
        return this.apiService.get('chemicals/new');
    }

    getForEdit(id: number): Observable<EditChemicalDto> {
        return this.apiService.get(`chemicals/${id}`);
    }

    create(dto: SaveChemicalDto): Observable<number> {
        return this.apiService.post('chemicals', dto);
    }

    update(id: number, dto: SaveChemicalDto): Observable<void> {
        return this.apiService.put(`chemicals/${id}`,dto);
    }

    delete(id: number): Observable<void> {
        return this.apiService.delete(`chemicals/${id}`);
    }

}
